const SPACE = '<div style="height:1px;background:#777;margin:4px 0;"></div>'

function line( type, value, index, lineNum ) {
  const c = type === 'Type' ? '#ffff00' : type === 'Variant' ? '#00ffff' : '#00ff00'
  const fs = index === 0 ? '16px' : '11px'
  const lbl = lineNum === 0 ? `${type}:` : ''
  return (
    '<div>' +
      `<div style="padding:2px 0;display:inline-block;color:#fff;width:70px;vertical-align:top;font-size:${fs};">${lbl}</div>` +
      `<div style="padding:2px 0;display:inline-block;color:${c};vertical-align:top;font-size:${fs};">${value}</div>` +
    '</div>'
  )
}

export default class Rollover {
  
  constructor( ) {
    this.active = false
    this.txt = ''
    this.element = document.createElement( 'div' )
    this.element.style.cssText = 'position:absolute;' +
      'pointer-events: none;' +
      'font-family: "Inter var","Open Sans",sans-serif;' +
      'top:30px;' +
      'right:30px;' +
      'min-width:200px;' +
      'padding:16px;' +
      'color:white;' +
      'background:rgba(0, 0, 0, 0.85);' +
      'border:1px solid #ddd;' +
      'z-index:100000;' + 
      'display:none;' 
    document.body.append( this.element )
  }

  toggleActive = ( v ) => {
    this.active = v === undefined ? !this.active : v
    this.setText( this.txt )
  }

  setHits( hits, evt ) {
    if ( hits == null || hits.length === 0 ) {
      this.element.style.display = 'none'
    }
    let txt = ''
    hits.forEach( ( h, i ) => {
      if ( i > 0 ) {
        txt += SPACE
      }
      const v = h.variant.split( '|' )
      txt += line( 'Type', h.type, i, 0 )
      v.forEach( ( e, idx ) => {
        txt += line( 'Variant', e, i, idx )
      } )

      if ( h.layout ) {
        const l = h.layout.split( '|' )
        l.forEach( ( e, idx ) => {
          txt += line( 'Layout', e, i, idx )
        } )
      }
      
    } )
    this.setText( txt, evt )
  }

  setText( txt, evt ) {
    const show = this.active || ( evt && evt.ctrlKey )
    this.element.style.display = !show || txt.trim().length == 0 ? 'none' : ' inline-block'
    this.txt = txt
    this.element.innerHTML = txt
    const r = window.outerWidth - ( evt != null ? evt.clientX : 0 ) > 380
    this.element.style.right = r ? '30px' : 'initial'
    this.element.style.left = !r ? '30px' : 'initial'
    
  }
}
